import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact'
import { isFrench } from '../config'

export default ({ facet }) => {
    const { toggleProductFilter } = useActions()

    return (
        <li class="ns-sidebar-dropdown ns-pt-reg">
            <div class="ns-sidebar-submenu">
                <ul class="ns-facet-list flex flex-col ns-list-unstyled">
                    {facet.data?.map((value) => {
                        if (value.value === "true") {
                            return <li class="">
                                <label class="ns-checkbox flex">
                                    <input
                                        type="checkbox"
                                        checked={value.selected}
                                        onChange={(e) => {
                                            e.preventDefault()
                                            toggleProductFilter(
                                                facet.field,
                                                value.value,
                                                !value.selected
                                            )
                                        }}
                                    />
                                    <span class="ns-checkmark"></span>
                                        {isFrench
                                            ?   'Afficher uniquement les Abonnements'
                                            :   'Show Subscribe & Save items only'
                                        }
                                </label>
                            </li>
                        }
                    })}
                </ul>
            </div>
        </li>
    )
}